import React from 'react';
import { Link } from 'react-router-dom';
import { FaCarSide, FaMotorcycle, FaTruck, FaWrench, FaRocket, FaMapLocation } from "react-icons/fa6";
import serviceArticles from '../common/serviceArticle';

export default function Service() {
    const icons = {
        "Pengiriman Mobil": <FaCarSide className='w-10 h-10 md:w-12 md:h-12 group-hover:text-black'/>,
        "Pengiriman Motor": <FaMotorcycle className='w-10 h-10 md:w-12 md:h-12 group-hover:text-black'/>,
        "Beban Berat": <FaTruck className='w-10 h-10 md:w-12 md:h-12 group-hover:text-black'/>,
        "Layanan Darurat": <FaWrench className='w-10 h-10 md:w-12 md:h-12 group-hover:text-black'/>,
        "Cepat Sampai Tujuan": <FaRocket className='w-10 h-10 md:w-12 md:h-12 group-hover:text-black'/>,
        "Towing Jarak Jauh": <FaMapLocation className='w-10 h-10 md:w-12 md:h-12 group-hover:text-black'/>
    };

    return (
        <section id='service' className='flex flex-col h-full min-h-screen w-full gap-12 justify-center items-center py-16 bg-gradient-to-b from-white via-gray-100 to-[#ffe600e7]'>
            <header className='w-full flex flex-col items-center gap-4'>
                <h2 className="text-5xl md:text-7xl font-['PoppinsB'] text-center">LAYANAN</h2>
                <div className="w-24 h-1 bg-[#fcfc00c0]"></div>
                <p className="text-gray-600 text-center max-w-2xl px-4">BBYSHIN menyediakan berbagai layanan derek profesional untuk segala jenis kendaraan</p>
            </header>

            <div className='w-full max-w-7xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-8'>
                {serviceArticles.map((service, index) => (
                    <Link
                        key={index}
                        to={`/service/${encodeURIComponent(service.service_name)}`}
                        className='group bg-white hover:bg-black cursor-pointer flex flex-col justify-center items-center p-8 rounded-2xl gap-4 shadow-lg hover:shadow-xl transform hover:-translate-y-1 duration-300 border border-gray-100'
                    >
                        <div className='w-20 h-20 md:w-24 md:h-24 rounded-full bg-[#fcfc00c0] flex items-center justify-center group-hover:bg-[#fcfc00]'>
                            {icons[service.service_name] || <FaCarSide className='w-10 h-10 md:w-12 md:h-12 group-hover:text-black'/>}
                        </div>
                        <h3 className='text-center text-xl md:text-2xl font-bold group-hover:text-[#fcfc00c0]'>{service.service_name}</h3>
                        <p className='text-center text-gray-600 group-hover:text-gray-300'>{service.service_desc}</p>
                    </Link>
                ))}
            </div>
        </section>
    );
}
